import { KeyValueDiffers, ViewContainerRef } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router } from "@angular/router";
import { LayoutPrintService } from "./layout-print.service";
var LayoutPrintComponent = (function () {
    function LayoutPrintComponent(differs, layoutPrintService, toastr, vcr, router) {
        this.differs = differs;
        this.layoutPrintService = layoutPrintService;
        this.toastr = toastr;
        this.vcr = vcr;
        this.router = router;
        this.toastr.setRootViewContainerRef(vcr);
        this.differ = this.differs.find({}).create();
    }
    LayoutPrintComponent.prototype.ngOnInit = function () {
        this.title = "Layout Print";
        this.filterParams = {
            size: 10,
            page: 0
        };
    };
    LayoutPrintComponent.prototype.ngDoCheck = function () {
        var change = this.differ.diff(this.filterParams);
        if (change) {
            if (this.filterParams.page < 0) {
                this.filterParams.page = 0;
                return;
            }
            else if (this.filterParams.page > this.totalPage - 1) {
                this.filterParams.page = this.totalPage - 1;
                return;
            }
            this.getLayoutPrintList();
        }
    };
    LayoutPrintComponent.prototype.getLayoutPrintList = function () {
        var _this = this;
        this.isLoading = true;
        this.layoutPrintService.getLayoutPrintList(this.filterParams)
            .then(function (res) {
            if (res.status === 1) {
                _this.layoutPrintList = res.data.dataList;
                _this.totalElements = res.data.totalElements;
                _this.initPaginate();
            }
            else {
                _this.toastr.error(res.message, 'Error!');
                if (res.errorCode === 3000) {
                    localStorage.setItem("alert", JSON.stringify(res.message));
                    _this.router.navigate(['login']);
                }
            }
            _this.isLoading = false;
        })
            .catch(function (err) { return console.log(err); });
    };
    //init paging 
    LayoutPrintComponent.prototype.initPaginate = function () {
        this.totalPage = Math.ceil(this.totalElements / this.filterParams.size);
        var arrPagingNumber = [];
        for (var i = 0; i < this.totalPage; i++) {
            arrPagingNumber.push(i);
        }
        return arrPagingNumber;
    };
    LayoutPrintComponent.prototype.deleteLayoutPrint = function (layoutPrint) {
        var _this = this;
        if (confirm("Confirm delete " + layoutPrint.name + "?")) {
            this.layoutPrintService.deleteLayoutPrint(layoutPrint.id)
                .then(function (res) {
                if (res.status == 1) {
                    _this.toastr.success(res.data, 'Success!');
                    _this.getLayoutPrintList();
                }
                else {
                    _this.toastr.error(res.message, 'Error!');
                    if (res.errorCode === 3000) {
                        localStorage.setItem("alert", JSON.stringify(res.message));
                        _this.router.navigate(['login']);
                    }
                }
            }).catch(function (err) { return console.log(err); });
        }
    };
    return LayoutPrintComponent;
}());
export { LayoutPrintComponent };



// WEBPACK FOOTER //
// /build/client-cms/src/app/layout-print/layout-print.component.ts.pre-build-optimizer.js